import { useState, useEffect } from "react";
import CardSeplag from "../../../components/CardSeplag";
import CardExibirPdf from "../../../components/CardExibirPDF";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import download from "downloadjs";
import { MultiSelect } from "primereact/multiselect";
import {
  carregarArvoreRag,
  carregarArvoreRagPermissao,
  buscarUoPorIdenExercicio,
  buscarUoPorExercicioPermissoes,
  buscarPrograma,
  buscaProgramaPermissao,
  gerarPDFRagExecOrcam,
  buscaProgramaExercicio,
} from "../../../service/Rag/ArvoreRag";

const RelatorioExecucaoOrcamentaria = () => {
  const user = useSelector((state) => state.userReducer.user);
  const [exibirRelatorio, setExibirRelatorio] = useState(false);
  const TipoRelatorio = [
    { name: "PDF", code: "P" },
    { name: "EXCEL", code: "E" },
  ];
  const [tituloPDF, setTituloPDF] = useState("");
  const [dadosRelatorioBase64, setDadosRelatorioBase64] = useState(null);
  const [isExibirPDF, setIsExibirPDF] = useState(false);
  const [data, setData] = useState({
    listaExercicio: [],
    listaPrograma: [],
    listaUO: [],
    isExibirPDF: false,
    tituloPDF: null,
    dadosRelatorioBase64: "",
    isMONRL_ADMIN_CENTRAL: buscarPerfil("MONRL_ADMIN_CENTRAL"),
    isMONRL_ANALISTA: buscarPerfil("MONRL_ANALISTA"),
    isMONRL_ACESSO_ORGAO_CONTROLE: buscarPerfil("MONRL_ACESSO_ORGAO_CONTROLE"),
  });
  const [filter, setFilter] = useState({
    selectedExercicio: null,
    selectedPrograma: null,
    selectedUO: null,
    isExibirPDF: false,
    tipoRelatorio: { name: "PDF", code: "P" },
  });

  function buscarPerfil(pNomeRole) {
    let retorno = false;
    if (user) {
      user.contaAcesso.authorities.forEach((perfilUser) => {
        if (perfilUser.nomeRole === pNomeRole) {
          retorno = true;
        }
      });
    } else {
      retorno = false;
    }

    return retorno;
  }

  const buscarArvoreByPermissa = async () => {
    if (data.isMONRL_ADMIN_CENTRAL || data.isMONRL_ANALISTA || data.isMONRL_ACESSO_ORGAO_CONTROLE) {
      carregarArvoreRag().then((response) => {
        return setData((prevState) => ({
          ...prevState,
          listaExercicio: response.listaExercicios,
        }));
      });
    } else {
      carregarArvoreRagPermissao().then((_response) => {
        return setData((prevState) => ({
          ...prevState,
          listaExercicio: _response.listaExercicios,
        }));
      });
    }
  };

  function fecharJanela() {
    setExibirRelatorio(false);
    setIsExibirPDF(false);
  }

  useEffect(() => {
    buscarArvoreByPermissa();
  }, []);

  const onChangeExercicio = async (e) => {
    setData((prevState) => ({
      ...prevState,
      listaPrograma: null,
      listaUO: null,
    }));
    setFilter((prevState) => ({
      ...prevState,
      selectedExercicio: e.value,
      selectedPrograma: null,
      selectedUO: null,
    }));
    if (e.value !== undefined) {
      let JsonBody = {
        idenExercicio: e.value.idenExercicio,
        listaEixo: null,
        flagTipoPrograma: null,
      };
      if (data.isMONRL_ADMIN_CENTRAL || data.isMONRL_ANALISTA || data.isMONRL_ACESSO_ORGAO_CONTROLE) {
        let v_listaPrograma = await buscarPrograma(JsonBody).then((res) => {
          return res.data;
        });
        let v_listaUo = await buscarUoPorIdenExercicio(e.value.idenExercicio).then((_res) => {
          return _res.data;
        });
        setData({ ...data, listaUO: v_listaUo, listaPrograma: v_listaPrograma });
      } else {
        let v_listaPrograma = await buscaProgramaPermissao(JsonBody).then((res) => {
          return res.data;
        });
        let v_listaUo = await buscarUoPorExercicioPermissoes(e.value.idenExercicio).then((_res) => {
          return _res.data;
        });

        setData({ ...data, listaUO: v_listaUo, listaPrograma: v_listaPrograma });
      }
    }
  };
  const onChangePrograma = (e) => {
    setFilter((prevState) => ({
      ...prevState,
      selectedPrograma: e.value,
    }));
  };

  const onChangeUo = (e) => {
    setFilter((prevState) => ({
      ...prevState,
      selectedUO: e.value,
    }));
  };
  const onChangeTipoRelatorio = (e) => {
    setFilter((prevState) => ({
      ...prevState,
      tipoRelatorio: e.value,
    }));
  };

  const gerarRelatorio = () => {
    let listaPrograma =
      filter.selectedPrograma && filter.selectedPrograma != null
        ? filter.selectedPrograma.map((element) => element.idenPrograma)
        : [];
    let listaUnidOrcamentaria =
      filter.selectedUO && filter.selectedUO != null ? filter.selectedUO.map((element) => element.idenUo) : [];
    let idenExercicio =
      filter.selectedExercicio && filter.selectedExercicio != null ? filter.selectedExercicio.idenExercicio : 0;

    let tipoRelatorio = filter.tipoRelatorio.code;

    let JsonBody = {
      idenExercicio,
      listaPrograma,
      listaUnidOrcamentaria,
      tipoRelatorio,
    };
    gerarPDFRagExecOrcam(JsonBody).then((res) => {
      if (filter.tipoRelatorio.code === "E") {
        setIsExibirPDF(false);
        download(
          `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.dadosRelatorioBase64}`,
          `${res.data.nomeArquivo}`,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      } else {
        let valorMb = res.data.dadosRelatorioBase64.length / 1024000;
        if (valorMb > 2) {
          download(
            `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`,
            `${res.data.nomeArquivo}`,
            "application/pdf"
          );
        } else {
          setTituloPDF(res.data.nomeArquivo);
          setDadosRelatorioBase64(res.data.dadosRelatorioBase64);
          setIsExibirPDF(true);
        }
      }
    });
  };
  return (
    <CardSeplag title="RELATÓRIO DE EXECUÇÃO ORÇAMENTARIA">
      <div className="p-fluid grid line-height-6">
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-4 ">
              <label>Exercício</label>
              <Dropdown
                emptyFilterMessage="Opção não encontrada"
                id="idenExercicio"
                value={filter.selectedExercicio}
                options={data.listaExercicio}
                onChange={onChangeExercicio}
                optionLabel="ano"
                filter
                showClear
                filterBy="ano"
                placeholder="Selecione um exercício"
              />
            </div>
          </div>
          <div className="p-fluid grid line-height-4">
            <div className="field col-12 md:col-6 ">
              <label>Programa</label>
              <MultiSelect
                emptyFilterMessage="Opção não encontrada"
                id="idenPrograma"
                value={filter.selectedPrograma}
                options={data.listaPrograma}
                onChange={onChangePrograma}
                dataKey="idenPrograma"
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione um Programa"
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-6">
              <label>Unidade Orçamentária da Ação</label>
              <MultiSelect
                emptyFilterMessage="Opção não encontrada"
                id="idenUo"
                value={filter.selectedUO}
                options={data.listaUO}
                onChange={onChangeUo}
                dataKey="idenUo"
                optionLabel="descricaoFiplan"
                filter
                showClear
                filterBy="descricaoFiplan"
                placeholder="Selecione uma U.O."
                display="chip"
              />
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="selTipo">Tipo de Impressão do Relatório</label>
              <Dropdown
                emptyMessage="Dados não encontrados"
                id="code"
                value={filter.tipoRelatorio}
                options={TipoRelatorio}
                onChange={onChangeTipoRelatorio}
                optionLabel="name"
                showClear
                filterBy="true"
                placeholder="Selecione um Tipo de Impressão de Relatório"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 md:col-2">
        <Button type="button" label="Gerar" icon="pi pi-file-pdf" className="col-3 col-12" onClick={gerarRelatorio} />
        {isExibirPDF && (
          <CardExibirPdf
            tamanhoTela="'85.vw'"
            alturaTela="'350.vh'"
            stringPDF={"data:application/pdf;base64," + dadosRelatorioBase64}
            tituloTela={tituloPDF}
            isExibirPDF={isExibirPDF}
            position="center"
            onHide={fecharJanela}
          />
        )}
      </div>
    </CardSeplag>
  );
};

export default RelatorioExecucaoOrcamentaria;
